var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header"},[_c('button',{staticClass:"page-header__link",on:{"click":_vm.goBack}},[_c('i',{staticClass:"el-icon-arrow-left"}),_vm._v("Назад ")]),_vm._v(" | "),_c('h3',{staticClass:"page-header__title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }